import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service'; 
import { RepresentationApiService } from '../../services/representation-api.service';
import { SaveRepresentationItemsComponent } from '../save-representation-items/save-representation-items.component';


@Component({
  selector: 'crm-representation-items',
  templateUrl: './representation-items.component.html',
  styleUrls: ['./representation-items.component.css']
})
export class RepresentationItemsComponent implements OnInit {

  
  displayMode: DisplayModes = DisplayModes.Success;
  representationItems: any[] = [];
  selectedRepresentationItemsId;

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() representationId: number;

  @ViewChild('representationItemModal')
  representationItemModal: ModalDirective;

  @ViewChild('representationItemEditor')
  representationItemEditor: SaveRepresentationItemsComponent;

  @ViewChild('deleteRepresentationItemModal')
  deleteRepresentationItemModal: ModalDirective;

  constructor(private readonly representationService: RepresentationApiService,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService) { }

  ngOnInit() {
    this.getRepresentationItems();
  }

  ngAfterViewInit() {
    this.representationItemEditor.changesCallback = () => {
      this.getRepresentationItems();
      this.representationItemModal.hide();
    };
  }

  getRepresentationItems() {
    this.displayMode = DisplayModes.Loading;
    this.representationService.getRepresentationItems(this.representationId).subscribe(response => {
      this.representationItems = response as any[];
      this.displayMode = DisplayModes.Success;
    }, err => {
      console.log(err);
      this.displayMode = DisplayModes.Error;
    });
  }

  confirmDelete(representationItemId) {
    this.selectedRepresentationItemsId = representationItemId;
    this.deleteRepresentationItemModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.representationService.deleteRepresentationItem(this.selectedRepresentationItemsId).subscribe(() => {
      this.selectedRepresentationItemsId = undefined;
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("DeletedSuccessfully"), MessageSeverity.Default);
      this.getRepresentationItems();
    }, (error) => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  hideDeleteModal() {
    this.deleteRepresentationItemModal.hide();
  }

  back() {
    this.closeEvent.emit(true);
  }

  addNew() {
    this.representationItemEditor.new(this.representationId, this.representationItems);
    this.representationItemModal.show();
  }


  edit(representationItem) {
    this.representationItemEditor.edit(representationItem, this.representationItems);
    this.representationItemModal.show();
  }

  onEditorModalHidden() {
    this.representationItemModal.hide();
  }


}
